"use client";

import { FC } from "react";
import { usePostHog } from "posthog-js/react";

import { ISummaryDetailed } from "./types";
import SummaryDetailedRemoveWhyFresh from "./experiments/SummaryDetailedRemoveWhyFresh";
import SummaryDetailedOriginal from "./archived/SummaryDetailedOriginal";

const SummaryDetailed: FC<ISummaryDetailed> = (props) => {

  const posthog = usePostHog();

  const isMeta = props.flowSlug === "fresh-food-new-user";
  if (!isMeta && props.isTrial && posthog.getFeatureFlag("retry-remove-why-fresh-from-suf-3") === "test") {
    return (<SummaryDetailedRemoveWhyFresh { ...props } />);
  }

  return (<SummaryDetailedOriginal { ...props } />);

};

export default SummaryDetailed;
